import { useState, useEffect, useRef } from "react";

const usePagination = (page, changePage, limit, initialData, filter) => {
  const [currentPage, setCurrentPage] = useState(page);
  const [resultData, setResultData] = useState(initialData);

  const mounted = useRef();
  useEffect(() => {
    setCurrentPage(page);
    setResultData(initialData);
  }, [initialData, limit, page]);

  useEffect(() => {
    if (mounted.current) {
      changePage(currentPage, limit, filter).then((res) => {
        setResultData(res.data);
      });
    } else {
      mounted.current = true;
    }
  }, [currentPage]);
  console.log(limit);

  return [currentPage, resultData, setCurrentPage];
};

export default usePagination;
